import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function MobileStickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-94">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-[#F9A8B7]/30 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] px-4 py-3" data-id="element-95">
          <a href="#oferta" className="flex items-center justify-between gap-3 bg-[#F9A8B7] hover:bg-[#EC8FA1] text-white font-bold text-base py-3.5 px-5 rounded-full shadow-md transition-colors" data-id="element-96">
            <div className="flex flex-col text-left leading-tight" data-id="element-97">
              <span className="text-xs opacity-90 line-through font-medium" data-id="element-98">
                $49.99
              </span>
              <span data-id="element-99">QUIERO MIS RECETAS · $14.99</span>
            </div>
            <ArrowRightIcon className="w-5 h-5 flex-shrink-0" data-id="element-100" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}